// Import Assets
import EquipmentServiceIllustration from '../../assets/Illustrations/Services/Equipment_Illustration.jpg';
import ListServiceIllustration from '../../assets/Illustrations/Services/List_Illustration.jpg';
import ComparatorServiceIllustration from '../../assets/Illustrations/Services/Comparator_Illustration.jpg';

// Exports
export const equipmentServiceIllustration = EquipmentServiceIllustration;
export const listServiceIllustration = ListServiceIllustration;
export const comparatorServiceIllustration = ComparatorServiceIllustration;
